'use client';

import React, { FC } from 'react';

import { H1 } from '@repo/ui-kit/components/core/Typography';

import TextBlock from 'strapi/component/shared/TextBlock/TextBlock';
import { FlexColumn } from 'styles/layouts';

import { LandingButton } from '../landingButton';
import { MediaElement } from '../shared/mediaElement';
import { ComponentContainer, ComponentWrapper } from '../shared/styles';

import { Description } from './styles';
import { MediaSpotlightProps } from './types';
const analyticsMeta = { componentName: 'imageSectionSingle' };

// imageSectionSingle in strapi
export const MediaSpotlight: FC<MediaSpotlightProps> = ({
  title,
  description,
  button,
  media,
}) => {
  return (
    <ComponentWrapper>
      <ComponentContainer>
        <FlexColumn gap="48px">
          <FlexColumn alignItems="center" gap="24px">
            <FlexColumn alignItems="center" gap="16px">
              <H1 bold as="h2" textAlign="center">
                {title}
              </H1>
              {description && (
                <Description>
                  {description && <TextBlock text={description} />}
                </Description>
              )}
            </FlexColumn>
            {button && (
              <LandingButton
                analyticsMeta={analyticsMeta}
                isSignUp={button.isSignUp}
                label={button.label}
                url={button.url}
              />
            )}
          </FlexColumn>
          <MediaElement
            {...media}
            aspectRatio="16/9"
            objectFit={
              'legacyStyles' in media && media.legacyStyles
                ? 'contain'
                : 'cover'
            }
          />
        </FlexColumn>
      </ComponentContainer>
    </ComponentWrapper>
  );
};
